import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=093efb3f&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093efb3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('093efb3f')) {
      api.createRecord('093efb3f', component.options)
    } else {
      api.reload('093efb3f', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=093efb3f&scoped=true", function () {
      api.rerender('093efb3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/offStore/manager/edit.vue"
export default component.exports